import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Button,
  HStack,
  useDisclosure,
} from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import { usePlanUsage } from '../hooks/usePlanUsage';
import { formatExceededLimitsMessage } from '../utils/planUsage';
import UpgradePlanModal from './UpgradePlanModal';

const UsageLimitBanner: React.FC = () => {
  const { user } = useAuth();
  const { hasReachedLimit, exceededLimits, isLoading } = usePlanUsage();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isAdmin = user?.role === 'admin';

  if (isLoading || !hasReachedLimit) {
    return null;
  }

  const message = formatExceededLimitsMessage(exceededLimits, isAdmin ? 'admin' : 'member');
  const title = isAdmin ? 'Plan limit reached' : 'Workspace limit reached';

  return (
    <>
      <Alert
        status="warning"
        borderRadius="xl"
        mb={6}
        boxShadow="sm"
        flexDirection={{ base: 'column', md: 'row' }}
        alignItems={{ base: 'flex-start', md: 'center' }}
        gap={3}
      >
        <HStack align="flex-start" flex="1">
          <AlertIcon />
          <Box>
            <AlertTitle fontSize="sm">{title}</AlertTitle>
            <AlertDescription fontSize="sm">{message}</AlertDescription>
          </Box>
        </HStack>
        {isAdmin && (
          <Button size="sm" colorScheme="orange" flexShrink={0} onClick={onOpen}>
            Upgrade plan
          </Button>
        )}
      </Alert>

      {isAdmin && (
        <UpgradePlanModal isOpen={isOpen} onClose={onClose} message={message} />
      )}
    </>
  );
};

export default UsageLimitBanner;
